import { PlusOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { WhatsNewItem } from 'Modules'
import React, { useState } from 'react'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import ProtectedButton from 'component/button/protected-button'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { FEATURE } from 'constants/feature'
import { useWhatsNewList } from 'hooks/whats-new'
import { WhatsNewFormModal, WhatsNewTable } from 'modules/whats-new'

import style from './style.module.scss'

const WhatsNewPage: React.FC = () => {
  const [modalVisible, setModalVisible] = useState(false)
  const [editingId, setEditingId] = useState<string | undefined>()
  const { total, maxItems, refetch } = useWhatsNewList()

  const additionalItems = [BREADCRUMBS.WHATS_NEW]
  const isCreateDisabled = total >= maxItems

  const handleOpenModal = () => {
    setEditingId(undefined)
    setModalVisible(true)
  }

  const handleEditItem = (item: WhatsNewItem) => {
    setEditingId(item._id)
    setModalVisible(true)
  }

  const handleCloseModal = () => {
    setEditingId(undefined)
    setModalVisible(false)
  }

  const handleSuccess = () => {
    refetch()
  }

  return (
    <div className={style.whatsNewPage}>
      <Breadcrumb additionalItems={additionalItems} />

      <div className={style.card}>
        <div className={style.header}>
          <div className={style.titleBlock}>
            <h1>What&apos;s New</h1>
            {total > 0 && (
              <span className={style.totalItems}>
                Total items: <strong>{total}</strong> / {maxItems} max
              </span>
            )}
          </div>
          <Tooltip
            title={isCreateDisabled ? 'Maximum 10 items. Delete an item to create a new one' : ''}
            overlayStyle={{ pointerEvents: 'none' }}
          >
            <ProtectedButton
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleOpenModal}
              disabled={isCreateDisabled}
              feature={FEATURE.WHATS_NEW_CREATE}
            >
              Create Item
            </ProtectedButton>
          </Tooltip>
        </div>

        <WhatsNewTable
          onEdit={handleEditItem}
          onRefresh={handleSuccess}
          onCreate={handleOpenModal}
        />
      </div>

      <WhatsNewFormModal
        visible={modalVisible}
        editingId={editingId}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
      />
    </div>
  )
}

export default WhatsNewPage
